import { useEffect, useState } from "react";

export const useResponsive = (maxWidthPx: number): boolean => {
  const [isBelow, setIsBelow] = useState<boolean>(() => window.innerWidth < maxWidthPx);

  useEffect(() => {
    const onChange = () => setIsBelow(window.innerWidth < maxWidthPx);
    onChange();
    window.addEventListener("resize", onChange);
    window.addEventListener("orientationchange", onChange);

    return () => {
      window.removeEventListener("resize", onChange);
      window.removeEventListener("orientationchange", onChange);
    };
  }, [maxWidthPx]);

  return isBelow;
};
